// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import Modal from '../common/Modal';


class CreateDSAWorkflowCustomerConfirmationModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      open,
      onDismiss,
      onDeny,
      onConfirm
    } = this.props;

    return (
      <div className='account-information svp-common-ui'>
        <div className='customer-convert-modal'>
          <Modal
            open={open}
            onDismiss={onDismiss}
          >
            <div className='row'>
              <div className='customer-convert-modal-header'>
                <h3>Is this PPT being generated for a customer?</h3>
              </div>
            </div>
            <div className='row'>
              <div className='customer-convert-modal-description'>
                <p>By selecting “Yes”, this Training assessment will be converted and at least one of the most relevant opportunities must be linked. Linking opportunities provides insights into how deals are assisted by SVP and how it can be further improved.</p>
              </div>
            </div>
            <div className='row'>
              <div className='customer-convert-modal-content'>
                <div className='col-sm-6 customer-convert-type-alignment'>
                  <Button
                    onClick={onDeny}
                    onEnterKey={onDeny}
                    label='No'
                  />
                </div>
                <div className='col-sm-6 customer-convert-type-alignment'>
                  <Button
                    onClick={onConfirm}
                    onEnterKey={onConfirm}
                    label='Yes'
                    primary
                  />
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

CreateDSAWorkflowCustomerConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func,
  onDeny: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default CreateDSAWorkflowCustomerConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/account/CreateDSAWorkflowCustomerConfirmationModal.js